import { DocumentEntityType } from '@/domains/documents/enums/DocumentEntityType';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class DocumentCreatedEvent extends EventV2<{ entityType: DocumentEntityType; entityKey: string }> {}
